import { isNaN } from 'lodash'
import Vue from 'vue'

Vue.config.productionTip = false

const renderHandler = (selector, render) => {
  const initInstances = () => {
    let elements = document.querySelectorAll(
      `[data-dotcom-component="${selector}"]`,
    )

    /* sanitisedComponentsList: List of components for which we checked that it works in all places to mount them with the data-dotcom-component attribute version.
     * So that it does not need the legacy way via tag names.
     * End goal is to use component loading via tag names only in nested components.
     */
    const sanitisedComponentsList = ['dotcom-breadcrumb']

    // Temporary fallback for the transition period
    if (!elements.length && !sanitisedComponentsList.includes(selector)) {
      elements = document.querySelectorAll(selector)
      if (elements.length) {
        console.log(
          'mounter: component renderer uses old component selector, please check!',
          selector,
        )
      }
    }

    for (let i = 0; i < elements.length; i++) {
      elements[i].removeAttribute('data-dotcom-component')
      render(elements[i])
    }
  }

  if (window.Sanitas) {
    window.Sanitas.dotcom = window.Sanitas.dotcom || {}
    window.Sanitas.dotcom.instances = window.Sanitas.dotcom.instances || {}
    window.Sanitas.dotcom.instances[selector] = initInstances
  }

  initInstances()
}

export const mount = function (
  selector,
  components,
  props = {},
  otherConfigs = {},
) {
  let render
  if (!components.name) {
    render = element => {
      new Vue({
        el: element,
        components,
        propsData: { ...(element ? element.dataset : {}), ...props },
      })
    }
  } else {
    render = element => {
      new Vue({
        ...otherConfigs,
        render: h =>
          h(components, {
            props: { ...(element ? element.dataset : {}), ...props },
          }),
      }).$mount(element)
    }
  }

  renderHandler(selector, render)
}

export const mountComponentTag = function (
  selector,
  component,
  props = {},
  withSlot = false,
  store = {},
) {
  let render = element => {
    const propsFromElement = Array.from(element.attributes).reduce(
      (acc, attr) => {
        // handle non-string properties
        if (attr.nodeName.indexOf(':') === 0) {
          let value = attr.nodeValue

          // numeric
          if (!isNaN(value)) {
            value = Number(value)
          }
          // @todo: implement object and array when/if a usecase shows up
          acc[attr.nodeName.slice(1)] = value
        } else {
          acc[attr.nodeName] = attr.nodeValue
        }
        return acc
      },
      {},
    )

    /* The attrs are needed for the Icon component to provide control attributes for the vue fontawesome component FLEX-1184 */
    new Vue({
      store,
      render: h =>
        h(component, {
          ...(propsFromElement.class ? { class: propsFromElement.class } : {}),
          ...(propsFromElement.style ? { style: propsFromElement.style } : {}),
          props: { ...propsFromElement, ...props },
          attrs: { ...propsFromElement },
          ...(withSlot
            ? {
                domProps: {
                  innerHTML: element.innerHTML,
                },
              }
            : {}),
        }),
    }).$mount(element)
  }

  renderHandler(selector, render)
}
